import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import TextInputWithButton from 'app/Components/Shared/TextInputWithButton/TextInputWithButton';
import { validateAbroadCoupon, setAbroadCoupon } from 'app/Components/Block/CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {validateInput, TextInputEnum} from 'app/utilities/validation/InputValidation';
function AbroadCoupon(props) {
  
  const [isOpen, setIsOpen] = useState(false);

  const validateCoupon = async () => {
    const error = validateInput(props.coupon?.code, TextInputEnum.CouponCode);
    if (error) {
      props.setAbroadCoupon({...props.coupon, error: error, isLoading: false});
    }else{
      const channel = props.activeLobbyTab && props.activeLobbyTab == 'businessAccount' ? 'C' : 'I';
      const result = await props.validateAbroadCoupon({soc_code: props.selectedAbroadPackage.socCatalogId, coupon_code: props.coupon?.code, phoneNumber: props.subscriber, channel: channel});
    if(result.payload.Body.isSuccess){
      var voucherAmount = result.payload.Body.priceAfterVoucher;
      if(voucherAmount  == props.selectedAbroadPackage?.price ){
        props.setAbroadCoupon({...props.coupon,isValid: false, error: 'משהו השתבש יש לפנות לנציג קוד שגיאה 225301', isLoading: false});
      }

    }
   
    }
  };

  const handleInputChange = (value) => {
    props.setAbroadCoupon({ ...props.coupon, code: value, error: '', isLoading: false});
    const error = validateInput(value, TextInputEnum.CouponCode);
    if (error) {
      props.setAbroadCoupon({ ...props.coupon, code: value, error: error, isLoading: false});
    }
  }
  

  const displayCouponTicket = props.coupon?.isValid  && props.coupon?.code;

  return (
    <> { !props.coupon?.isValid  &&
      <div className='dashed-border-box'/>
    }
    <div className='abroad-coupon-container'>
      <div className='abroad-coupon'>
        <div className='abroad-coupon-header'>{displayCouponTicket ?
         <> הקוד הופעל בהצלחה</> : (
          <>
            <Image src={require('./images/coupon.svg')} alt='coupon' /> 
            <span>&nbsp;יש לי קוד קופון</span>
            <Image className={isOpen ? 'arrow-open' : 'arrow-closed'} src={require('./images/arrow.svg')} alt='arrow' onClick={() => setIsOpen(!isOpen)} />
          </>
        )}
        </div>


        {displayCouponTicket ? (
          <div className='abroad-coupon-valid'>
            <Image src={require('./images/price.svg')} alt='price' />
            <span>{props.coupon?.code}</span>
            <Image src={require('./images/close.svg')} alt='close' onClick={() => {props.setAbroadCoupon({code: '', isValid: false, voucherAmount: 0, error: '', isLoading: false});}} />
          </div>
        ) : (
          <> { isOpen && 
          <TextInputWithButton 
            placeholder='הזינו קוד קופון'
            buttonAction={validateCoupon}
            error={props.coupon?.error}
            isLoading={props.coupon?.isLoading}
            disabled={props.coupon?.isLoading}
            buttonText='הפעל'
            floatingPlaceHolderEnabled={false}
            onChange={(e) => {
              handleInputChange(e.target.value);
            }}
            value={props.coupon?.code}
            />}
          </>
        )}
     </div>

  </div>
  </>
  );
}

const mapStateToProps = (state) => {
  return {
    isJETAuthentication: state.cellcomAbroad.isJETAuthentication,
    activeLobbyTab: state.cellcomAbroad.activeLobbyTab,
    selectedAbroadPackage: state.cellcomAbroad.selectedAbroadPackage,
    epiStyleInitializationData: state.cellcomAbroad.epiStyleInitializationData,
    userData: state.authentication?.loginData?.userDetails,
    subscriber: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
      ? state.cellcomAbroad.businessIndividualData.selectedAccountNumber
      : state.cellcomAbroad.otpData.otpPhone || state.authentication.loginData.userDetails.contactNumber,
    countriesCode: state.cellcomAbroad.selectedCountries,
    isLoading: state.cellcomAbroad.isLoading,
    coupon: state.cellcomAbroad.coupon,
  };
};

const mapDispatchToProps = {
  validateAbroadCoupon,
  setAbroadCoupon,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadCoupon);
